// extracted by mini-css-extract-plugin
export default {"status":"FrequencyStatusLink_status__9SwM4","error":"FrequencyStatusLink_error__yohWs","warning":"FrequencyStatusLink_warning__qi-l8"};